export default [
  {
    path: window.pathApp + '/autenticacao',
    name: 'autenticacao',
    component: () => import('@/components/Autenticacao'),
    meta: {
      login: false,
      avisoCarrinho: false,
      title: "Autenticação",
    }
  },
  {
    path: window.pathApp + '/logoff',
    name: 'logoff',
    component: () => import('@/components/Logoff'),
    meta: {
      login: true,
      avisoCarrinho: false,
      title: "Logoff",
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/autenticacao.js